<template>
	<div class="min-vh-100 d-flex flex-column justify-content-between">
		<div class="d-flex align-items-md-center">
			<div class="container px-3 mb-5">
				<div class="row justify-content-center">
					<div class="col-md-9 col-lg-7 col-xl-6 col-hd-5">
						<nuxt />
					</div>
				</div>
			</div>
			<toast-container-component />
		</div>
		<footer-component :reserve-cookie-banner-space="true" />
		<client-only>
			<CookieBanner @open-settings="showCookieSettings = true" />
			<CookieSettingsModal
				v-if="showCookieSettings"
				@close="showCookieSettings = false"
			/>
		</client-only>

		<PortalTarget name="tooltip-root" multiple />
	</div>
</template>

<script>
import ToastContainerComponent from '~/components/toast-container'
import FooterComponent from '~/components/footer'
import CookieBanner from '~/components/ui/banners/CookieBanner'
import CookieSettingsModal from '~/components/ui/modals/CookieSettingsModal'
import { PUBLIC_SEO_DESCRIPTION, PUBLIC_SEO_TITLE } from '~/constants/seo'

export default {
	head() {
		return {
			title: PUBLIC_SEO_TITLE,
			titleTemplate: chunk => chunk || PUBLIC_SEO_TITLE,
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{
					hid: 'og:title',
					property: 'og:title',
					content: PUBLIC_SEO_TITLE
				},
				{
					hid: 'og:description',
					property: 'og:description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{
					hid: 'twitter:title',
					name: 'twitter:title',
					content: PUBLIC_SEO_TITLE
				},
				{
					hid: 'twitter:description',
					name: 'twitter:description',
					content: PUBLIC_SEO_DESCRIPTION
				},
				{ hid: 'robots', name: 'robots', content: 'index, follow' }
			]
		}
	},
	middleware: ['outdatedBrowser'],
	components: {
		ToastContainerComponent,
		FooterComponent,
		CookieBanner,
		CookieSettingsModal
	},
	data() {
		return {
			showCookieSettings: false
		}
	}
}
</script>
